import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { formatDate, formatToInputDate } from "../../../Utils/DateUtlis";
import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { companyGet, employeeGet, truckTripGetbyCompany, truckTripPut } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";
import { PencilSquare } from "react-bootstrap-icons";

const TruckTripView = () => {
  const [apiData, setApiData] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [loadingCompany, setLoadingComapany] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    company_id: null,
    trip_month: ''
  });
  const [editData, setEditData] = useState({
    company_id: null,
    emp_id: '',
    trip_date: '',
    trip_cost: '',
    remarks: ''
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setOrganizations(companies);
          setLoadingComapany(false)
          console.log(`API Data ${JSON.stringify(organizations)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany();
  }, []);

  const handleEditSubmit = async () => {
    setShowModal(false)
    console.log(`Edited Data : ${JSON.stringify(editData)}`);
    try {
      const responseData = await truckTripPut(selectedTrip, editData);
      if (responseData) {
        alert(`Trip updated Successfully.....`);
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  const getDriver = async (id) => {
    try {
      const response = await employeeGet(id);
      if (response && response.result) {
        const driver = response.result.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          designation: i.designation
        })).filter(dri => dri.designation === 'DRIVER-4');
        setDrivers(driver);
        console.log('Driver Data: ', drivers);
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    console.log(`Name: ${name} And Value ${value}`);
    setEditData(prev => ({
      ...prev,
      [name]: value
    }));
    if (name === 'company_id') {
      getDriver(value)
    }
    if (name === 'emp_id') {
      console.log(`Name: ${name} And Value ${value}`);

    }

  }

  const handleEdit = (tripData) => {
    setSelectedTrip(tripData.id)
    console.log(`Selected Trip ID: ${selectedTrip}`);

    // setEditData(tripData);
    setEditData({
      ...tripData,
      trip_date: formatToInputDate(tripData.trip_date)
    })
    console.log("Trip Data ", tripData);

    setShowModal(true);
  }

  const handleModalClose = () => {
    setShowModal(false);
    setEditData(null);
  }

  const handleButton = () => {
    navigate('/addTruckTrip')
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const responseData = await truckTripGetbyCompany(formData);
      console.log('Response Data: ', JSON.stringify(responseData));

      if (responseData && responseData.results) {
        console.log(`Inside If results`);
        const trips = responseData.results.map(i => ({
          id: i._id,
          emp_id: i.emp_id,
          NAME: i.NAME,
          trip_date: i.trip_date,
          trip_cost: i.trip_cost,
          trip_pay: i.trip_pay,
          remarks: i.remarks
        }));
        console.log(JSON.stringify(trips));

        setApiData(trips);
        setIsLoading(false);
      } else {
        alert('No Data Received')
      }
    } catch (err) {
      setIsLoading(true);
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title='Truck Trip' showButtons={true} />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Truck Trip Details
          <div className="d-flex flex-column align-items-end">
            <Button variant="primary" className="d-flex align-items-center mb-2" onClick={handleButton}>
              Add Trip
            </Button>
          </div>
        </h4>
        <Form onSubmit={handleSubmit} className="mt-4 align-items-center">
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="company_id">
              <Form.Label>Organization Name</Form.Label>
              <Form.Select
                name="company_id"
                value={formData.company_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Organization</option>
                {loadingCompany ? (<div>Loading...</div>) : (organizations.map(org => (
                  <option key={org.id} value={org.id}>{org.name}</option>
                )))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='4' controlId="trip_month">
              <Form.Label>Select Month</Form.Label>
              <Form.Control
                type="month"
                name="trip_month"
                value={formData.trip_month}
                onChange={handleChange}
                required
                style={{height:'30px'}}
              >
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} md='4'>
              <Button type="submit" variant="primary" className="d-flex align-items-center mb-2" style={{ marginTop: '25px',height:'30px' }}>
                View Trip
              </Button>
            </Form.Group>
          </Row>
        </Form>
        {isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span className="sr-only">No Data to Show</span>
          </div>
        </div> : <div style={{ overflow: 'auto' }}>
          <Table striped hover responsive='sm' size="sm">
            <thead>
              <tr>
                <th className="fs-12">Name</th>
                <th className="fs-12">Trip Date</th>
                <th className="fs-12">Trip Cost</th>
                <th className="fs-12">Trip Pay</th>
                <th className="fs-12">Remarks</th>
                <th className="fs-12">Actions</th>
              </tr>
            </thead>
            <tbody>
              {apiData.map((trp, i) => (
                <tr key={trp.id}>
                  <td className="fs-12">
                    {trp.NAME}
                  </td>
                  <td className="fs-12">
                    {formatDate(trp.trip_date)}
                  </td>
                  <td className="fs-12">
                    {trp.trip_cost}
                  </td>
                  <td className="fs-12">
                    {trp.trip_pay}
                  </td>
                  <td className="fs-12">
                    {trp.remarks}
                  </td>
                  <td>
                    <Button variant="outline-primary" size="sm" onClick={() => handleEdit(trp)}><PencilSquare /></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        }
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Truck Trip</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {editData && (
              <Form onSubmit={(e) => {
                e.preventDefault();
                handleEditSubmit();
              }}>
                <Form.Group className="mb-3" controlId="company_id">
                  <Form.Label>Name</Form.Label>
                  <Form.Select
                    name="company_id"
                    value={editData.organizationName}
                    required
                    onChange={handleEditChange}
                  // onChange={(e) => {
                  //   setEditData({ ...editData, company_id: e.target.value });
                  //   getDriver(e.target.value)
                  // }}
                  >
                    <option value="">Select Organization</option>
                    {organizations.map(org => (
                      <option key={org.id} value={org.id}>{org.name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3" controlId="emp_id">
                  <Form.Label>Employee Name</Form.Label>
                  <Form.Select
                    name="emp_id"
                    value={editData.emp_id}
                    onChange={handleEditChange}
                    // onChange={(e) => setEditData({ ...editData, emp_id: e.target.value })}
                    required
                  >
                    {/* <option value="">Select Driver</option> */}
                    {drivers.map(driver => {
                      console.log('Selected Driver Id', driver.emp_id);
                      return (

                        <option key={driver.emp_id} value={driver.emp_id}>{driver.emp_name}</option>
                      )
                    })}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3" controlId="trip_date">
                  <Form.Label>Trip Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="trip_date"
                    value={editData.trip_date}
                    onChange={handleEditChange}
                    // onChange={(e) => setEditData({ ...editData, trip_date: e.target.value })}
                    required
                  >
                  </Form.Control>
                </Form.Group>
                <Form.Group className="mb-3" controlId="trip_cost">
                  <Form.Label>Trip Cost</Form.Label>
                  <Form.Control
                    type="number"
                    name="trip_cost"
                    value={editData.trip_cost}
                    onChange={handleEditChange}
                    // onChange={(e) => setEditData({ ...editData, trip_cost: e.target.value })}
                    required
                  >
                  </Form.Control>
                </Form.Group>
                <Button variant="primary" type="submit">
                  Submit
                </Button>
              </Form>
            )}
          </Modal.Body>
        </Modal>
      </Container>
    </div>
  );

}

export default TruckTripView;